<template>
  <div>
    <div
      class="productCard full-height relative-position bg-white"
    >
      <div
        class="row productCard--upper"
      >
        <q-img
          src="../../../public/offer.png"
          class="offer-img"
          style="z-index: 1;"
        />
        <div class="row col-xs-12 col-sm-3 q-pa-sm-lg content-center justify-center">
          <q-img
            v-if="productModel.hasImages()"
            :src="productModel.getCoverImage().src"
            :srcset="productModel.getCoverImage().srcset"
          />
          <q-icon
            v-else
            size="80px"
            color="grey-3"
            name="mdi-image"
          />
        </div>

        <div class="col-xs-12 col-sm-9 q-pa-md">
          <div
            class="text-uppercase"
            style="font-size: 32px; font-weight: 700"
          >
            {{ productModel.getTitle() }}
          </div>
          <div
            class="text-body2 text-prewrap q-mt-md"
            style="font-size: 16px; font-weight: 400"
          >
            {{ productModel.getShortDescription() }}
          </div>
          <div class="row q-pt-xl">
            <div
              v-if="productModel.totalPrice > 0"
              class="col-xs-grow text-h6 text-weight-bold"
            >
              {{ formatPriceISK(productModel.totalPrice) }}
            </div>
            <div
              v-if="isOpen"
              class="row col-xs-shrink q-ml-sm-md"
            >
              <q-btn
                rounded
                class="text-weight-bold text-black q-mr-sm"
                color="yellow-14"
                size="15px"
                :label="$t('order.order')"
                @click="gotoProduct"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ProductModel from 'quasar-pilot-core/src/lib/models/product';
import CategoryModel from 'quasar-pilot-core/src/lib/models/category';
import priceFormatter from 'quasar-pilot-core/src/mixins/format/price';
import vuexUtils from 'quasar-pilot-core/src/mixins/util/vuex';
import errorDialog from 'quasar-pilot-core/src/mixins/errorDialog';

export default {
  name: 'OfferProductCard',
  mixins: [priceFormatter, vuexUtils, errorDialog],
  props: {
    product: {
      type: Object,
      required: true,
    },
    categoryId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      productModel: null,
      quantity: 1,
    };
  },

  computed: {
    ...mapState('location', { currentLocation: 'current' }),
    ...mapGetters('location', ['getDefaultLocation']),
    ...mapGetters('category', ['findCategory']),
    isOpen() {
      const offerCategory = this.findCategory(this.categoryId);
      const category = new CategoryModel(offerCategory);
      return category.isCategoryOpen(category) && !this.currentLocation.closed;
    },
  },

  created() {
    this.productModel = new ProductModel(this.product);
  },

  methods: {
    gotoProduct() {
      this.$router.push({
        name: 'ViewProduct',
        params: {
          productId: this.productModel.id,
          categoryId: this.categoryId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.productCard {
  box-shadow: 0 12px 15px 0 #0000001A;
  min-height: 193px;
  border-radius: 10px;
  &--upper {
    min-height: 104px;
  }
  .offer-img {
    position: absolute;
    top: 0;
    height: 140px;
    > div {
      padding-bottom: 0!important;
    }
    &:deep(.q-img__image) {
      background-size: unset!important;
      background-position: unset!important;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
